import SpinnerLoader from "@/app/component/spinner-loader";
import { Modal } from "react-bootstrap";
import Image from "next/image";
import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { useState } from "react";
import GenderModalV2 from "../../../ProfileProfileInfoPage/v2/components/GenderModal";
import { t } from "i18next";

export function InputTextBoxV2({
  mainClassName = "myinput",
  isDisabled = false,
  isEditable = false,
  hasError = true,
  hint = "",
  suffix,
  isShowSuffix = false,
  showLoader = false,
  showCancelButton = false,
  isGenderModalOpen,
  setIsGenderModalOpen,
  handleValueChange,
  list,
  handleKeyDown,
  inputPlaceHolder = "",
  ...props
}: any) {
  console.log("value in input field", {
    props: props.name,
    typeofHANDLE: handleValueChange,
  });

  const { config, getImagePath } = useClientConfigProvider();

  const capitalizedPlaceholder =
    props.placeholder?.charAt(0).toUpperCase() + props.placeholder.slice(1);
  const handleClearInput = () => {
    if (props.onChange && typeof props.onChange === "function") {
      props.onChange({ target: { name: props.name, value: "" } });
    }
  };
  console.log("haserror", hasError);

  const [searchTerm, setSearchTerm] = useState("");
  const handleScrollOrArrowKey = (e: any) => {
    console.log("scrolling or arrow key pressed");
    e.preventDefault();
    e.target.blur();

    // Prevent the page/container from scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const updateGender = (val: string) => {
    console.log("updateegender", val, typeof handleValueChange);
    handleValueChange(val);
  };
  return (
    <div className={mainClassName}>
      {/* <Image
        src={props.image}
        alt="Image"
        width="500"
        height="500"
        className="user-image"
      /> */}
      <div
        className={`d-flex  input-field-v2  ${
          props.value ? "filled-v2" : ""
        }    ${hasError ? "error" : "inputfocus"}`}
        style={{
          gap: "8px",
        }}
      >
        <input
          id={`input-${props.name}`}
          className={`${hasError ? "error" : ""}`}
          onWheel={(e) => {
            handleScrollOrArrowKey(e);
          }}
          autoCapitalize="off"
          onKeyDown={(e) => {
            console.log("scrollingor", e.key);
            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
              handleScrollOrArrowKey(e);
            }
            handleKeyDown?.(e);
          }}
          onBlur={props.onBlur}
          disabled={isDisabled}
          type="text"
          style={{
            color: isDisabled
              ? "var(--LightTheme-Disable)"
              : "var(--color-grayscale-text-negative)",
            outline: "none",
            border: "none",
            width: "100%",
            // background: isDisabled
            //   ? "transparent"
            //   : "var(--LightTheme-Input-input_background)",
          }}
          {...props}
          placeholder={inputPlaceHolder}
          // autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          autoComplete="new-password"
        />
        {capitalizedPlaceholder && (
          <label
            className={`${hasError ? "error" : ""}`}
            htmlFor={`input-${props.name}`}
          >
            {capitalizedPlaceholder}
          </label>
        )}

        {showCancelButton && props.value && (
          <div
            style={{ fontSize: "10px", cursor: "pointer" }}
            className="btn-close"
            onClick={handleClearInput}
          ></div>
        )}
        {showLoader && (
          <div className="suffix-btn" style={{ width: "30px", height: "30px" }}>
            <SpinnerLoader />
          </div>
        )}

        {suffix && isShowSuffix && (
          <div className={` suffix-btn-v2 ${hasError ? "error" : ""}`}>
            {suffix}
          </div>
        )}
      </div>

      {hasError && (
        <></>
        // <div className="error-message" style={{ paddingLeft: "5px" }}>
        //   {/* <ErrorMessage className="error-message" name={props.name} /> */}
        //   {/* {errorMessage && <div className="error-message">{errorMessage}</div>} */}
        // </div>
      )}
    </div>
  );
}
